"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardPanelContext = void 0;
const react_1 = require("react");
/**
 * @deprecated Use PageWizardPanelContainerContext for Modal containerRef
 */
exports.PageWizardPanelContext = (0, react_1.createContext)({
    activate() {
        // no-op
    },
    deactivate() {
        // no-op
    },
    element: null,
    isShrink: false
});
//# sourceMappingURL=PageWizardPanelContext.js.map